<ion-content class="modal-outher-container">
  <ion-grid class="
      modal-inner-container 
      modal-inner-container--scroll 
      community__modal--height
    ">

    <ion-row>
      <ion-col size="12">
        <app-modal-header 
          [header]="headerText" 
          (close)="back()"
        ></app-modal-header>
      </ion-col>

      <ion-col size="12">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">

          <ion-row>
            <!-- Left column -->
            <ion-col size="6">

              <!-- Typ komunikatu -->
              <div class="mb-3">
                <ion-label position="stacked" class="fw-bold">{{ "COMMUNITY.AI.KIND.LABEL" | translate }}</ion-label>
                <ion-radio-group [formControlName]="FormControls.TYPE">
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.KIND.EVENT" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="DescriptionType.EVENT"></ion-radio>
                  </ion-item>
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.KIND.TECHNICAL_INFORMATION" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="DescriptionType.TECHNICAL_INFORMATION"></ion-radio>
                  </ion-item>
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.KIND.ADMINISTRATIVE_ANNOUNCEMENT" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="DescriptionType.ADMINISTRATIVE_ANNOUNCEMENT"></ion-radio>
                  </ion-item>
                </ion-radio-group>
              </div>

              <!-- Styl komunikatu -->
              <div class="mb-3">
                <ion-label position="stacked" class="fw-bold">{{ "COMMUNITY.AI.STYLE.LABEL" | translate }}</ion-label>
                <ion-radio-group [formControlName]="FormControls.STYLE">
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.STYLE.INFORMAL" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="MessageStyle.INFORMAL"></ion-radio>
                  </ion-item>
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.STYLE.NEUTRAL" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="MessageStyle.NEUTRAL"></ion-radio>
                  </ion-item>
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.STYLE.FORMAL" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="MessageStyle.FORMAL"></ion-radio>
                  </ion-item>
                </ion-radio-group>
              </div>

            </ion-col>

            <!-- Right column -->
            <ion-col size="6">

              <!-- Długość -->
              <div class="mb-3">
                <ion-label position="stacked" class="fw-bold">{{ "COMMUNITY.AI.MESSAGE_LENGTH.LABEL" | translate }}</ion-label>
                <ion-radio-group [formControlName]="FormControls.LENGTH">
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.MESSAGE_LENGTH.SHORT" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="MessageLength.SHORT"></ion-radio>
                  </ion-item>
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.MESSAGE_LENGTH.STANDARD" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="MessageLength.STANDARD"></ion-radio>
                  </ion-item>
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.MESSAGE_LENGTH.EXTENDED" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="MessageLength.EXTENDED"></ion-radio>
                  </ion-item>
                </ion-radio-group>
              </div>

              <!-- Emoji -->
              <div class="mb-3">
                <ion-label position="stacked" class="fw-bold">{{ "COMMUNITY.AI.EMOJI.LABEL" | translate }}</ion-label>
                <ion-radio-group [formControlName]="FormControls.EMOJIS">
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.EMOJI.YES" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="true"></ion-radio>
                  </ion-item>
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.EMOJI.NO" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="false"></ion-radio>
                  </ion-item>
                </ion-radio-group>
              </div>

              <!-- Języki -->
              <div class="mb-3">
                <ion-label position="stacked" class="fw-bold">{{ "COMMUNITY.AI.MESSAGE_LANGUAGE.LABEL" | translate }}</ion-label>
                <ion-radio-group [formControlName]="FormControls.LANGUAGE">
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.MESSAGE_LANGUAGE.POLISH" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="Language.POLISH"></ion-radio>
                  </ion-item>
                  <ion-item class="w-100">
                    <ion-label>{{ "COMMUNITY.AI.MESSAGE_LANGUAGE.ENGLISH" | translate }}</ion-label>
                    <ion-radio slot="start" [value]="Language.ENGLISH"></ion-radio>
                  </ion-item>
                </ion-radio-group>
              </div>
            </ion-col>
          </ion-row>

          <!-- Bottom row -->
          <ion-row>
            <!-- Informacje główne -->
            <ion-col size="12">
              <div class="mb-3">
                <ion-label 
                  position="stacked" 
                  class="fw-bold"
                >{{ "COMMUNITY.AI.MAIN_INFO.LABEL" | translate }}</ion-label>
                <ion-textarea 
                  [formControlName]="FormControls.MAIN_INFORMATION"
                  [placeholder]='("COMMUNITY.AI.MAIN_INFO.PLACEHOLDER" | translate)' 
                  rows="5"
                ></ion-textarea>
              </div>
            </ion-col>
          </ion-row>

          <!-- Submit btn -->
          <div class="w-100 mt-2 mb-2">
            <ng-container *ngIf="!generatedDescription; else loader">
              <ion-button 
                expand="block" 
                type="submit"
              >{{ "COMMUNITY.AI.SUBMIT_BTN" | translate }}</ion-button>

              <ion-toast 
                [isOpen]="isToastOpen"
                message="Uzupełnij wszystkie pola formularza przed wygenerowaniem treści." 
                [duration]="3000"
                position="top" 
                (didDismiss)="setOpen(false)"
              ></ion-toast>
            </ng-container>
          </div>

        </form>

      </ion-col>

      <!-- Generated output -->
      <ion-col 
        *ngIf="messages.length > 0" 
      >
        <ion-label 
          position="stacked" 
          class="fw-bold justify-content-center text-center"
        >{{ "COMMUNITY.AI.GENERATED_COMMUNITY" | translate }}</ion-label>
        
        <ion-list>
          <ion-item 
            *ngFor="let msg of messages" 
            class="community__message" 
            lines="none" 
            (click)="selectMessage(msg)"
          >
            <ion-label>{{ msg.message }}</ion-label>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>

  </ion-grid>
</ion-content>

<ng-template #loader>
  <div 
    class=" 
      w-100 h-100 
      d-flex flex-column 
      justify-content-center 
      align-items-center"
    >
    <img 
      src="../../../../assets/loading.svg" 
      alt="Loading" 
    >
    <ion-label>{{ "COMMUNITY.AI.LOADING" | translate }}</ion-label>
  </div>
</ng-template>